// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg[data-v-02f081fb]{vertical-align:bottom;width:2rem}.primary[data-v-02f081fb]{fill:url(#primary-linear-gradient)}.warning[data-v-02f081fb]{fill:#fcbe24}.danger[data-v-02f081fb]{fill:#e23434}text[data-v-02f081fb]{font-size:max(1.6rem,40%);fill:#fff;font-weight:700;text-anchor:middle}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
